(() => {
  const API_URL = 'https://storesboost-steven-beivue.laravel.cloud/api/product-requests/shopify-popup';
  const DEFAULT_CONTEXT = {
    title: "Tell Us What You're Looking For",
    subtitle: "Can't find what you need? Send us a request.",
    submitLabel: 'Submit Request',
    successTitle: 'Request submitted',
    successMessage: 'Thanks. Our team will review it and follow up if needed.',
    productTitle: '',
    extraPayload: {},
  };

  if (window.ProductRequestModalInitialized) return;
  window.ProductRequestModalInitialized = true;

  function initProductRequestModal() {
    if (document.getElementById('pr-modal-root')) return;

    const style = document.createElement('style');
    style.textContent = `
      .pr-modal-overlay {
        position: fixed;
        inset: 0;
        z-index: 99999;
        display: none;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.35);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        padding: 16px;
      }

      .pr-modal-overlay.is-active {
        display: flex;
      }

      html.pr-modal-open,
      body.pr-modal-open {
        overflow: hidden !important;
        height: 100%;
      }

      /* Horizon scrolls .page-wrapper instead of the document at 990px and up. */
      html.pr-modal-open .page-wrapper {
        overflow: hidden !important;
      }

      .pr-modal {
        width: 100%;
        max-width: 460px;
        background: #ffffff !important;
        background-image: none !important;
        color: #111111;
        opacity: 1;
        border-radius: 16px;
        padding: 24px;
        position: relative;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
      }

      .pr-modal,
      .pr-modal * {
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
      }

      .pr-modal__close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 40px;
        height: 40px;
        border: 0;
        background: transparent;
        cursor: pointer;
        font-size: 24px;
        line-height: 1;
        color: #111111;
      }

      .pr-modal__title {
        margin: 0 0 6px;
        font-size: 22px;
        font-weight: 700;
        color: #111111;
      }

      .pr-modal__sub {
        margin: 0 0 18px;
        font-size: 14px;
        color: #555555;
      }

      .pr-modal__field {
        margin-bottom: 14px;
      }

      .pr-modal__field label {
        display: block;
        margin-bottom: 6px;
        font-size: 13px;
        font-weight: 600;
        color: #111111;
      }

      .pr-modal__field input,
      .pr-modal__field textarea {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid rgba(127, 127, 127, 0.25);
        border-radius: 10px;
        padding: 11px 12px;
        font: inherit;
        background: #ffffff;
        color: #111111;
      }

      .pr-modal__field textarea {
        min-height: 110px;
        resize: vertical;
      }

      .pr-modal__error {
        display: none;
        margin-bottom: 12px;
        color: #b42318;
        font-size: 13px;
        white-space: pre-wrap;
      }

      .pr-modal__error.is-active {
        display: block;
      }

      .pr-modal__actions {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        margin-top: 8px;
      }

      .pr-modal__success {
        display: none;
        text-align: center;
        padding: 16px 8px 4px;
        color: #111111;
      }

      .pr-modal__success.is-active {
        display: block;
      }

      .pr-modal__form.is-hidden {
        display: none;
      }
    `;
    document.head.appendChild(style);

    const modal = document.createElement('div');
    modal.id = 'pr-modal-root';
    modal.className = 'pr-modal-overlay';
    modal.innerHTML = `
      <div class="pr-modal" role="dialog" aria-modal="true" aria-labelledby="pr-modal-title">
        <button type="button" class="pr-modal__close" aria-label="Close">&times;</button>

        <form class="pr-modal__form" id="pr-modal-form">
          <h2 id="pr-modal-title" class="pr-modal__title">Tell Us What You're Looking For</h2>
          <p class="pr-modal__sub">Can’t find what you need? Send us a request.</p>

          <div class="pr-modal__error" id="pr-modal-error"></div>

          <div class="pr-modal__field">
            <label for="pr-name">Name *</label>
            <input id="pr-name" name="customer_name" type="text" required>
          </div>

          <div class="pr-modal__field">
            <label for="pr-phone">Phone number *</label>
            <input id="pr-phone" name="customer_phone" type="tel" required>
          </div>

          <div class="pr-modal__field">
            <label for="pr-email">Email *</label>
            <input id="pr-email" name="customer_email" type="email" required>
          </div>

          <div class="pr-modal__field">
            <label for="pr-product">Product requested *</label>
            <input id="pr-product" name="product_title" type="text" required>
          </div>

          <div class="pr-modal__field">
            <label for="pr-notes">Notes</label>
            <textarea id="pr-notes" name="notes"></textarea>
          </div>

          <div class="pr-modal__actions">
            <button type="button" class="button button--secondary" id="pr-cancel">Cancel</button>
            <button type="submit" class="button" id="pr-submit">Submit Request</button>
          </div>
        </form>

        <div class="pr-modal__success" id="pr-modal-success">
          <h3>Request submitted</h3>
          <p>Thanks. Our team will review it and follow up if needed.</p>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    const overlay = modal;
    const form = modal.querySelector('#pr-modal-form');
    const successView = modal.querySelector('#pr-modal-success');
    const errorEl = modal.querySelector('#pr-modal-error');
    const closeBtn = modal.querySelector('.pr-modal__close');
    const cancelBtn = modal.querySelector('#pr-cancel');
    const submitBtn = modal.querySelector('#pr-submit');
    const titleEl = modal.querySelector('#pr-modal-title');
    const subtitleEl = modal.querySelector('.pr-modal__sub');
    const successTitleEl = modal.querySelector('#pr-modal-success h3');
    const successMessageEl = modal.querySelector('#pr-modal-success p');

    const nameInput = modal.querySelector('#pr-name');
    const phoneInput = modal.querySelector('#pr-phone');
    const emailInput = modal.querySelector('#pr-email');
    const productInput = modal.querySelector('#pr-product');
    const notesInput = modal.querySelector('#pr-notes');
    let modalContext = { ...DEFAULT_CONTEXT };

    function resetForm() {
      errorEl.textContent = '';
      errorEl.classList.remove('is-active');
      form.classList.remove('is-hidden');
      form.reset();
      successView.classList.remove('is-active');
      submitBtn.disabled = false;
      submitBtn.textContent = DEFAULT_CONTEXT.submitLabel;
    }

    function prefillCustomer() {
      const customer = window.productRequestCustomer || {};
      if (!customer.isLoggedIn) return;
      if (customer.name) nameInput.value = customer.name;
      if (customer.email) emailInput.value = customer.email;
      if (customer.phone) phoneInput.value = customer.phone;
    }

    function applyContext(context) {
      modalContext = {
        ...DEFAULT_CONTEXT,
        ...(context || {}),
        extraPayload: {
          ...DEFAULT_CONTEXT.extraPayload,
          ...((context && context.extraPayload) || {}),
        },
      };

      titleEl.textContent = modalContext.title;
      subtitleEl.textContent = modalContext.subtitle;
      submitBtn.textContent = modalContext.submitLabel;
      successTitleEl.textContent = modalContext.successTitle;
      successMessageEl.textContent = modalContext.successMessage;

      if (modalContext.productTitle) {
        productInput.value = modalContext.productTitle;
      }
    }

    function openModal(context) {
      resetForm();
      prefillCustomer();
      applyContext(context);
      overlay.classList.add('is-active');
      document.documentElement.classList.add('pr-modal-open');
      document.body.classList.add('pr-modal-open');
      document.body.style.touchAction = 'none';
    }

    function closeModal() {
      overlay.classList.remove('is-active');
      document.documentElement.classList.remove('pr-modal-open');
      document.body.classList.remove('pr-modal-open');
      document.body.style.touchAction = '';
    }

    window.openProductRequestModal = openModal;

    closeBtn.addEventListener('click', closeModal);
    cancelBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeModal();
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-product-request-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openModal({
        productTitle: trigger.dataset.productTitle || '',
        title: trigger.dataset.productRequestTitle || DEFAULT_CONTEXT.title,
        subtitle: trigger.dataset.productRequestSubtitle || DEFAULT_CONTEXT.subtitle,
        submitLabel: trigger.dataset.productRequestSubmitLabel || DEFAULT_CONTEXT.submitLabel,
        successTitle: trigger.dataset.productRequestSuccessTitle || DEFAULT_CONTEXT.successTitle,
        successMessage: trigger.dataset.productRequestSuccessMessage || DEFAULT_CONTEXT.successMessage,
        extraPayload: {
          variant_id: trigger.dataset.variantId || '',
          variant_title: trigger.dataset.variantTitle || '',
          source: trigger.dataset.productRequestSource || '',
          request_type: trigger.dataset.productRequestType || '',
        },
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      errorEl.textContent = '';
      errorEl.classList.remove('is-active');

      if (!nameInput.value.trim() || !phoneInput.value.trim() || !emailInput.value.trim() || !productInput.value.trim()) {
        errorEl.textContent = 'Please complete all required fields.';
        errorEl.classList.add('is-active');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      const fd = new FormData();
      fd.append('customer_name', nameInput.value.trim());
      fd.append('customer_phone', phoneInput.value.trim());
      fd.append('customer_email', emailInput.value.trim());
      fd.append('product_title', productInput.value.trim());
      fd.append('notes', notesInput.value.trim());
      Object.entries(modalContext.extraPayload || {}).forEach(([key, value]) => {
        if (value != null && String(value).trim() !== '') {
          fd.append(key, String(value));
        }
      });

      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          body: fd,
          headers: {
            Accept: 'application/json, text/plain, */*'
          }
        });

        const raw = await response.text();
        console.log('product request status:', response.status);
        console.log('product request response:', raw);

        let data = {};
        try {
          data = raw ? JSON.parse(raw) : {};
        } catch (e) {}

        if (!response.ok) {
          throw new Error(
            data.message ||
            data.error ||
            raw ||
            `Request failed with status ${response.status}`
          );
        }

        form.classList.add('is-hidden');
        successView.classList.add('is-active');
        setTimeout(closeModal, 2500);
      } catch (error) {
        console.error('Product request submit error:', error);
        errorEl.textContent = error.message || 'Failed to submit request.';
        errorEl.classList.add('is-active');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Request';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRequestModal);
  } else {
    initProductRequestModal();
  }
})();